import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { AssetsPathPipe } from './pipes/assets-url.pipe';
import { CamelToSnakePipe } from './pipes/camel-to-snake.pipe';
import { CountryCodePipe } from './pipes/country-code.pipe';
import { JsonPrettyPipe } from './pipes/json-pretty.pipe';
import { MicrosToNumberPipe } from './pipes/micros-to-number.pipe';
import { NamePipe } from './pipes/name.pipe';
import { PadStartPipe } from './pipes/pad-start.pipe';
import { PlatformNamePipe } from './pipes/platform-name.pipe';
import { RolePipe } from './pipes/role.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { SinceWhenPipe } from './pipes/since-when.pipe';
import { TranslatePartPipe } from './pipes/translate-part.pipe';
import { TrustUrlPipe } from './pipes/trust-url.pipe';
import { UiLanguagePipe } from './pipes/ui-language.pipe';
import { WhenPipe } from './pipes/when.pipe';

import { FormatCurrencyPipe } from './pipes/format-currency.pipe';
import { FormatDatePipe } from './pipes/format-date.pipe';
import { FormatGoalValuePipe } from './pipes/format-goal-value.pipe';
import { FormatMetricPipe } from './pipes/format-metric.pipe';
import { FormatNumberPipe } from './pipes/format-number.pipe';
import { FormatPercentPipe } from './pipes/format-percent.pipe';

import { AnimateHeightDirective } from '@app/shared/directives/animate-height.directive';
import { FormInputStatesDirective, InputFieldCustomClassesDirective } from './directives';
import { HeapDirective } from './directives/heap.directive';

import { FormsModule } from '@angular/forms';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { ProfilePicComponent, ToasterComponent } from './components';
import { AccountLogoComponent } from './components/account-logo/account-logo.component';
import { ConversionDelaySwitchComponent } from './components/conversion-delay-switch/conversion-delay-switch.component';
import { StatusIconComponent } from './components/status-icon/status-icon.component';
import { UserAvatarComponent } from './components/user-avatar/user-avatar.component';
import { PlatformLogoPipe } from './pipes/platform-logo.pipe';
import { ThousandSeparatorPipe } from './pipes/thousands.separator.pipe';
import { TruncatePipe } from './pipes/truncate.pipe';
import { WrapInParenthesisPipe } from './pipes/wrap-in-parenthesis.pipe';

import { ScrollToBottomDirective } from '@app/shared/directives/scroll-to-bottom.directive';
import { CampaignTypePipe } from '@app/shared/pipes/campaign-type.pipe';
import { MicrosPipe } from '@app/shared/pipes/micros.pipe';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { IconComponent } from './components/icon/icon.component';
import { OptTypeComponent } from './components/opt-type/opt-type.component';
import { PGCurrencySwitchComponent } from './components/pg-currency-switch/pg-currency-switch.component';
import { DelayedHoverDirective } from './directives/delayed-hover.directive';
import { CallbackPipe } from './pipes/callback.pipe';
import { ContainsPipe } from './pipes/contains.pipe';
import { CurrencySymbolPipe } from './pipes/currency-symbol.pipe';
import { ExplorerUrlPipe } from './pipes/explorer-url.pipe';
import { FormatLocalizedDatePatternPipe } from './pipes/format-localized-date-pattern.pipe';
import { GoalHintRangePipe } from './pipes/goal-hint-range.pipe';
import { GoalNamePipe } from './pipes/goal-name.pipe';
import { GoalValuePipe } from './pipes/goal-value.pipe';
import { MetricValueFullShortPipe } from './pipes/metric-value-full-short.pipe';
import { PlatformLinkPipe } from './pipes/platform-link.pipe';
import { SnakeToCamelPipe } from './pipes/snake-to-camel.pipe';
import { SortByOrderPipe } from './pipes/sort-by-order.pipe';
import { TranslateSectionPipe } from './pipes/translate-section.pipe';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    NzSwitchModule,
    NzToolTipModule,
    FormsModule,
    IconComponent,
    UserAvatarComponent,
    FormatNumberPipe,
    TranslatePartPipe,
    CurrencySymbolPipe,

    AssetsPathPipe,
    FormatDatePipe,
    FormatLocalizedDatePatternPipe,
    FormatMetricPipe,
    FormatPercentPipe,
    FormatCurrencyPipe,
    FormatGoalValuePipe,
    ThousandSeparatorPipe,
    NamePipe,
    RolePipe,
    WhenPipe,
    PadStartPipe,
    SafeHtmlPipe,
    TrustUrlPipe,
    SinceWhenPipe,
    JsonPrettyPipe,
    UiLanguagePipe,
    CountryCodePipe,
    CamelToSnakePipe,
    SnakeToCamelPipe,
    PlatformLogoPipe,
    PlatformLinkPipe,
    PlatformNamePipe,
    MicrosToNumberPipe,
    TruncatePipe,
    WrapInParenthesisPipe,
    ExplorerUrlPipe,
    ContainsPipe,
    MetricValueFullShortPipe,
    CampaignTypePipe,
    MicrosPipe,
    CallbackPipe,
    SortByOrderPipe,
    GoalNamePipe,
    GoalValuePipe,
    GoalHintRangePipe,
    TranslateSectionPipe,
    AccountLogoComponent,
    DelayedHoverDirective,
    FormInputStatesDirective,
    FormInputStatesDirective,
    HeapDirective,
    AnimateHeightDirective,
    ScrollToBottomDirective,
    InputFieldCustomClassesDirective,
    AnimateHeightDirective,
    ScrollToBottomDirective,
    InputFieldCustomClassesDirective,
    ProfilePicComponent,
    StatusIconComponent,
    ToasterComponent,
    OptTypeComponent,
    ConversionDelaySwitchComponent,
  ],
  declarations: [PGCurrencySwitchComponent],
  exports: [
    FormatDatePipe,
    FormatLocalizedDatePatternPipe,
    FormatNumberPipe,
    FormatMetricPipe,
    FormatPercentPipe,
    FormatCurrencyPipe,
    FormatGoalValuePipe,
    ThousandSeparatorPipe,
    NamePipe,
    RolePipe,
    WhenPipe,
    PadStartPipe,
    SafeHtmlPipe,
    TrustUrlPipe,
    SinceWhenPipe,
    JsonPrettyPipe,
    UiLanguagePipe,
    CountryCodePipe,
    CamelToSnakePipe,
    SnakeToCamelPipe,
    PlatformLogoPipe,
    PlatformLinkPipe,
    PlatformNamePipe,
    TranslatePartPipe,
    MicrosToNumberPipe,
    TruncatePipe,
    WrapInParenthesisPipe,
    AssetsPathPipe,
    ExplorerUrlPipe,
    ContainsPipe,
    CurrencySymbolPipe,
    MetricValueFullShortPipe,
    CampaignTypePipe,
    MicrosPipe,
    CallbackPipe,
    SortByOrderPipe,
    GoalNamePipe,
    GoalValuePipe,
    GoalHintRangePipe,
    TranslateSectionPipe,
    TranslateSectionPipe,

    DelayedHoverDirective,
    HeapDirective,
    ProfilePicComponent,
    StatusIconComponent,
    FormInputStatesDirective,
    AnimateHeightDirective,
    InputFieldCustomClassesDirective,
    ScrollToBottomDirective,
    AccountLogoComponent,
    ToasterComponent,
    UserAvatarComponent,
    OptTypeComponent,
    ConversionDelaySwitchComponent,
    PGCurrencySwitchComponent,
    IconComponent,
  ],
})
export class SharedDirectivesModule {}
